import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {AsyncPipe, NgIf} from "@angular/common";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {AuthService} from "../../../shared/services/auth.service";
import {WarningMessageComponent} from "../../../shared/components/messages/warning-message/warning-message.component";
import {SocialSigninButtonComponent} from "../../../shared/components/auth/social-signin-button/social-signin-button.component";

@Component({
    selector: 'app-welcome',
    imports: [
        FormsModule,
        NgIf,
        ReactiveFormsModule,
        RouterLink,
        WarningMessageComponent,
        SocialSigninButtonComponent
    ],
    templateUrl: './welcome.component.html',
    styleUrl: './welcome.component.scss'
})
export class WelcomeComponent implements OnInit {
  welcomeForm: FormGroup
  processing = false

    constructor(
      private activatedRoute: ActivatedRoute,
      public authSvc: AuthService,
      private router: Router
    ) {
      this.welcomeForm = new FormGroup({
        name: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.email, Validators.required]),
        password: new FormControl('', Validators.required)
      })
    }

  get name() { return this.welcomeForm.get('name') as FormControl }
  get email() { return this.welcomeForm.get('email') as FormControl }
  get password() { return this.welcomeForm.get('password') as FormControl }


  async ngOnInit() {
      const email = this.activatedRoute.snapshot.queryParams['email']

      if (!email) {
        await this.router.navigate(['/auth/signup'])
        return
      }

      this.welcomeForm.patchValue({
        email
      })
    }

  onLogin() {
    this.welcomeForm.markAllAsTouched()
    this.authSvc.resetErrors()
    if (this.welcomeForm.invalid) { return }
    this.processing = true
    this.authSvc.loginWithEmail(
      this.welcomeForm.get('email')?.value,
      this.welcomeForm.get('password')?.value
    )
      .then(async () => {
        await this.authSvc.updateDisplayName(this.welcomeForm.get('name')?.value)
        // await this.router.navigate(['/']);
      })
      .catch((err) => {
        this.authSvc.errorSelector(err)
        this.processing = false
      });
  }
}
